import { DataContextActionProps, ServerHealthDataState } from "types/data";
import { SET_KITE_CONNECT_STATUS, SET_SERVER_HEALTH_DATA } from "./actions";

// initial state
export const initialState: ServerHealthDataState = {
  serverHealthData: null,
  kiteStatus: false,
};

// ==============================|| DATA REDUCER ||============================== //

const healthReducer = (
  state = initialState,
  action: DataContextActionProps
): ServerHealthDataState => {
  switch (action.type) {
    case SET_SERVER_HEALTH_DATA: {
      return {
        ...state,
        serverHealthData: action.payload?.serverHealthData!,
      };
    }
    case SET_KITE_CONNECT_STATUS: {
      return {
        ...state,
        kiteStatus: action.payload?.kiteStatus!,
      };
    }

    default: {
      return state;
    }
  }
};

export default healthReducer;
